import React from "react"

import ReactTable from "react-table"

import { APIPost, APIGet } from "services/APIRequest"
import ConfigHost from "services/ConfigHost"

import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"

import { ISOToDateFormat, ISOToDateYMDAndFullTime } from "helpers/ConvertDate"
import { thaiBath } from "helpers/ConvertFormat"
import Datetime from "react-datetime";

import * as Alert from "alertService"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import Autocomplete from "components/Autocomplete/Select.jsx";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import ViewListIcon from '@material-ui/icons/ViewList';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import SearchIcon from "@material-ui/icons/Search";
import SendIcon from "@material-ui/icons/Send";

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Select from "components/CustomSelects/Select.jsx"

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import FormLabel from "@material-ui/core/FormLabel"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "15px"
  }
}


class ReportCaseSFPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

      startDateTime: "",
      endDateTime: "",
      dataListSettingKey: {},
      dataListSetting: [],
      dataTableList: [],
      dataTableListRaw: [],
      currentSettingId: ""
    }
  }
  componentDidMount() {
    // this.props.listsCallInTypeUpdate()

    // this.loadDataTableList(false)
    Alert.Loading(true)
    this.loadSettingDataList(() => {
      Alert.LoadingClose()
    })
  }
  loadSettingDataList = (callback) => {
    APIPost(UrlServer.URL_POST_IMPORT_EXCEL_LEAD_SETTING_DATA_LIST, {}, ({ datas }) => {
      var newConvertDatas = arrayObject(datas, [
        {
          oldKey: "_id",
          newKey: "value"
        },
        {
          oldKey: "description",
          newKey: "name"
        },
        {
          oldKey: "created_date_iso",
          newKey: "created_date_iso"
        },
        {
          oldKey: "total_leads",
          newKey: "total_leads"
        }
      ]
      )
      newConvertDatas.map((data, index) => {
        newConvertDatas[index]["name"] = data["name"] + " : " + ISOToDateYMDAndFullTime(data["created_date_iso"]) + " (" + data["total_leads"] + ")"
      })
      this.setState({
        dataListSetting: newConvertDatas
      }, () => {
        callback()
      });
    })
  }
  loadDataTableList = (writeExcel = false, callback) => {
    if (new Date(this.state.startDateTime).getTime() > new Date(this.state.endDateTime).getTime()) {
      WarningCallback('วันที่เริ่มต้อง น้อยกว่า วันสิ้นสุด!', () => {
        this.setState({ dataTableList: [] })
      })
      return
    }
    const dateS = this.state.startDateTime ? this.state.startDateTime : ""
    const dateE = this.state.endDateTime ? new Date(new Date(this.state.endDateTime).getTime() + 86399000).toISOString() : ""
    const dataForSend = {
      writeExcel: writeExcel,
      startdate: dateS,
      enddate: dateE,
      leadid: this.state.currentSettingId
    }

    Alert.Loading(true)
    APIPost(UrlServer.URL_POST_SENDSMS_GET, dataForSend, ({ datas }) => {
      if (datas.length == 0) {
        WarningCallback("ไม่มีข้อมูลการส่ง SMS", () => {
          this.setState({
            dataTableList: []
          })
        })
        return
      }

      var dataList = this.renderListData(datas)
      this.setState({
        dataTableListRaw: datas,
        dataTableList: dataList
      }, () => {
        Alert.LoadingClose()
        if (callback) callback(datas)
      })
    })
  }
  handleSendSMSById = (leadId, tel, index, sms_count) => {
    Alert.QuestionCallback("คุณต้องส่ง SMS ที่เบอร์ " + tel + " ใช่หรือไม่?", "yellow", () => {
      const dataToSend = {
        id: leadId,
      }
      APIPost(UrlServer.URL_POST_SENDSMS_BY_ID, dataToSend, (datas) => {
        SuccessCallback(datas.message, null, () => {
          var dataRaw = this.state.dataTableListRaw
          dataRaw[index].send_sms_count = sms_count + 1
          var dataList = this.renderListData(dataRaw)
          this.setState({
            dataTableList: dataList
          }, () => {

          })
        })
      })
    })
  }
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        no: key + 1,
        description: CData.lead_setting_id.description,
        Customer_Name: CData.first_name + " " + CData.last_name,
        Tel: CData.tel,
        Send_Sms_Date: ISOToDateFormat(CData.send_sms_date),
        sms_expired_date: ISOToDateYMDAndFullTime(CData.sms_expired_date),
        Count: CData.send_sms_count,
        actions: (
          <div className={"actions-right " + this.props.classes.buttonTable}>
            <Button
              className={this.props.classes.buttonTable}
              size="sm"
              round
              onClick={() => this.handleSendSMSById(CData._id, CData.tel, key, CData.send_sms_count)}
              color="warning"
              className="remove"
            >
              <div>Send SMS <SendIcon className="btn-icon" /></div>
            </Button>{" "}
          </div>
        )
      }
    })
  }

  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    })
  }
  handleChange = name => event => {

    this.setState({
      [name]: event.target.value
    })
  }

  handleSearch = () => {
    this.loadDataTableList(false)
  }
  handleDownloadExcelFile = () => {
    this.loadDataTableList(true, (datas) => {
      const response = {
        file: ConfigHost.HOST_API + "reports/" + datas.fileName,
      };
      document.location = response.file
    })
  }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <ViewListIcon />
                </CardIcon>
                ออกรายงาน
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer >
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={6} className="date-responsive">
                          <InputLabel className={classes.label}>
                            วันที่เริ่ม (วันที่ส่ง SMS ครั้งล่าสุด)
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              timeFormat={false}
                              onChange={e => this.handleDateTimeChange("startDateTime", e)}
                              inputProps={{
                                placeholder: "กดเลือกวันที่ตรงนี้",
                                readOnly: true
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6} className="date-responsive">
                          <InputLabel className={classes.label}>
                            ถึงวันที่ (วันที่ส่ง SMS ครั้งล่าสุด)
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              timeFormat={false}
                              onChange={e => this.handleDateTimeChange("endDateTime", e)}
                              inputProps={{ placeholder: "กดเลือกวันที่ตรงนี้", readOnly: true }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <GridContainer >
                            <GridItem xs={12} sm={12} md={2}>
                              <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                ชื่อข้อมูล Lead ที่นำเข้า
                              </FormLabel>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={10}>
                              {
                                (this.state.dataListSetting.length > 0) ?
                                  <Select
                                    value={this.state.currentSettingId}
                                    listData={this.state.dataListSetting}
                                    onChange={this.handleChangeState("currentSettingId")}
                                  />
                                  : ""
                              }
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                      </GridContainer>
                      <hr />
                      <GridContainer className={classes.mt4}>
                        <GridItem xs={12} sm={12} md={12}>
                          <Button
                            round
                            color="primary"
                            onClick={this.handleSearch}
                          >
                            <SearchIcon className={classes.icons} />
                            ค้นหา
                          </Button>
                          <span className="txt-c-dorg"> * จะไม่แสดงรายการที่หมดอายุแล้ว</span>
                          {/* {" "}
                          <Button
                            round
                            color="info"
                            onClick={this.handleDownloadExcelFile}
                          >
                            <CloudDownloadIcon className={classes.icons} />
                            ดาวน์โหลด
                          </Button> */}
                        </GridItem>
                      </GridContainer>
                      <hr />
                      <GridContainer className={classes.mt4}>
                        <GridItem xs={12} sm={12} md={12}>
                          <span>จำนวน {thaiBath(this.state.dataTableList.length, false)} รายการ</span>
                          <ReactTable
                            className="table-scroll"
                            data={this.state.dataTableList}
                            filterable
                            columns={[
                              {
                                Header: "No",
                                accessor: "no",
                                width: 50
                              },
                              {
                                Header: "Actions",
                                accessor: "actions",
                                sortable: false,
                                filterable: false,
                                width: 140,
                              }, 
                              {
                                Header: "Tel",
                                accessor: "Tel",
                                width: 170
                              },
                              {
                                Header: "Customer Name",
                                accessor: "Customer_Name",
                                width: 180
                              },
                              {
                                Header: "From Data",
                                accessor: "description",
                                width: 140
                              },
                              {
                                Header: "Settting Send SMS Date",
                                accessor: "Send_Sms_Date",
                                width: 210
                              },
                              {
                                Header: "SMS Expire Date",
                                accessor: "sms_expired_date",
                                width: 190
                              },
                              {
                                Header: "Count Sent SMS",
                                accessor: "Count",
                                width: 170
                              }
                              
                            ]}
                            defaultPageSize={10}
                            showPaginationTop
                          // showPaginationBottom={false}
                          // className="-striped -highlight"
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}
 
export default withStyles(styles)(ReportCaseSFPage)
